import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wcc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const authApi = {
  register: (payload) => api.post("/auth/register", payload).then((r) => r.data),
  login: (payload) => api.post("/auth/login", payload).then((r) => r.data),
  resetPassword: (payload) => api.post("/auth/reset-password", payload).then((r) => r.data),
  testLogin: () => api.post("/auth/test-login").then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data),
};

export const stateApi = {
  get: () => api.get("/state").then((r) => r.data),
  save: (state, change_summary) =>
    api.put("/state", { state, change_summary }).then((r) => r.data),
  versions: () => api.get("/state/versions").then((r) => r.data),
};

export const filesApi = {
  list: () => api.get("/files").then((r) => r.data),
  upload: (file, kind) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("kind", kind || "document");
    return api.post("/files", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  downloadUrl: (id) => `${API}/files/${id}/download`,
  delete: (id) => api.delete(`/files/${id}`).then((r) => r.data),
};

export const importApi = {
  csv: (file, account) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("account", account || "Imported");
    return api.post("/import/csv", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
};

export const advisorApi = {
  run: () => api.post("/advisor/run").then((r) => r.data),
  latest: () => api.get("/advisor/latest").then((r) => r.data),
};

export const creditApi = {
  optimize: () => api.post("/credit/optimize").then((r) => r.data),
  latest: () => api.get("/credit/latest").then((r) => r.data),
};

export const activityApi = {
  list: () => api.get("/activity").then((r) => r.data),
};

export const lifeStateApi = {
  get: () => api.get("/life/state").then((r) => r.data),
  save: (state, change_summary) =>
    api.put("/life/state", { state, change_summary }).then((r) => r.data),
};

export const lifeChatApi = {
  history: () => api.get("/life/chat/history").then((r) => r.data),
  clear: () => api.delete("/life/chat/history").then((r) => r.data),
};

export const lifeApi = {
  encouragement: (payload) => api.post("/life/encouragement", payload).then((r) => r.data),
};

export const wellnessStateApi = {
  get: () => api.get("/wellness/state").then((r) => r.data),
  save: (state, change_summary) => api.put("/wellness/state", { state, change_summary }).then((r) => r.data),
};
export const wellnessChatApi = {
  history: () => api.get("/wellness/chat/history").then((r) => r.data),
  clear: () => api.delete("/wellness/chat/history").then((r) => r.data),
};
export const wellnessApi = {
  encouragement: (payload) => api.post("/wellness/encouragement", payload).then((r) => r.data),
  dailyPlan: (payload) => api.post("/wellness/daily-plan", payload).then((r) => r.data),
};
export const syncApi = {
  health: () => api.post("/sync/health").then((r) => r.data),
};

export const centralApi = {
  overview: (payload) => api.post("/central/overview", payload).then((r) => r.data),
  reports: () => api.get("/central/reports").then((r) => r.data),
  saveReport: (payload) => api.post("/central/reports", payload).then((r) => r.data),
  deleteReport: (id) => api.delete(`/central/reports/${id}`).then((r) => r.data),
  getDigest: (week) => api.get("/central/digest", { params: week ? { week } : {} }).then((r) => r.data),
  generateDigest: (payload) => api.post("/central/digest", payload).then((r) => r.data),
  getPillars: () => api.get("/central/pillars").then((r) => r.data),
  savePillars: (state) => api.put("/central/pillars", { state }).then((r) => r.data),
};

export const rhythmApi = {
  get: () => api.get("/rhythm").then((r) => r.data),
  save: (state) => api.put("/rhythm", { state }).then((r) => r.data),
};
